module.exports = __webpack_public_path__ + "img/b-4.fd6790fc.jpg";